// Select strings (auto-merged by lib/i18n.ts).
export const en = {
  'ds.select.placeholder': 'Select…',
}

export const zhTW = {
  'ds.select.placeholder': '選擇…',
}
